module.exports = __webpack_public_path__ + "static/media/rental-counter.7dd9195f.jpg";